const getCartonQty = (lineItem, cartonQtyBySkuOrId) => {
  const directCartonQty = lineItem?.carton_qty ?? lineItem?.cartonQty;
  if (directCartonQty !== undefined && directCartonQty !== null) {
    return directCartonQty;
  }

  const keys = [lineItem?.id, lineItem?.sku, lineItem?.manufacturerSku]
    .filter((key) => key !== undefined && key !== null)
    .map(String);

  for (const key of keys) {
    const value = cartonQtyBySkuOrId instanceof Map
      ? cartonQtyBySkuOrId.get(key)
      : cartonQtyBySkuOrId?.[key];
    if (value !== undefined && value !== null) return value;
  }

  return null;
};

export function computeCartonMismatches(lineItems = [], cartonQtyBySkuOrId = {}) {
  return lineItems.reduce((mismatches, lineItem) => {
    const quantity = Number(lineItem?.quantity);
    const cartonQty = Number(getCartonQty(lineItem, cartonQtyBySkuOrId));

    if (
      !Number.isFinite(quantity) ||
      quantity <= 0 ||
      !Number.isFinite(cartonQty) ||
      cartonQty <= 1 ||
      quantity % cartonQty === 0
    ) {
      return mismatches;
    }

    const floorQuantity = Math.floor(quantity / cartonQty) * cartonQty;
    const ceilQuantity = Math.ceil(quantity / cartonQty) * cartonQty;
    mismatches.push({
      sku: lineItem?.sku || lineItem?.manufacturerSku || String(lineItem?.id || ''),
      quantity,
      cartonQty,
      floorQuantity,
      ceilQuantity,
    });
    return mismatches;
  }, []);
}
